import { createTheme } from '@mui/material/styles';

import { baseColors } from './colors';

export const getCommonThemesProps = (themeColors) => ({
  palette: {
    colors: {
      ...themeColors,
    },
    gradientes: {
      state: {
        cancel: `linear-gradient(110deg, ${themeColors.down} 30%, ${themeColors.secondaryBackground} 30%, ${themeColors.secondaryBackground}  50%, ${themeColors.down} 50%, ${themeColors.down} 80%, ${themeColors.secondaryBackground}  80%, ${themeColors.secondaryBackground}  100%);`,
        expired: `linear-gradient(110deg, ${themeColors.lower} 30%, ${themeColors.secondaryBackground} 30%, ${themeColors.secondaryBackground}  50%, ${themeColors.lower} 50%, ${themeColors.lower} 80%, ${themeColors.secondaryBackground}  80%, ${themeColors.secondaryBackground}  100%);`,
        rejected: `linear-gradient(110deg, ${themeColors.secondaryBackground}, ${themeColors.secondaryBackground} 35%,  ${themeColors.down} 35%,  ${themeColors.down} 45%, ${themeColors.secondaryBackground} 45%, ${themeColors.secondaryBackground} 55%,  ${themeColors.down} 55%,  ${themeColors.down} 65%, ${themeColors.secondaryBackground} 65%, ${themeColors.secondaryBackground} 100% );`,
        parcExecuted: `linear-gradient(to right, ${themeColors.star} ,${themeColors.star} 50%,${themeColors.secondaryBackground} 50%, ${themeColors.secondaryBackground} 100%)`,
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: themeColors.primaryBackground,
        },

        /* Change autocomplete styles in WebKit */
        'input:-webkit-autofill,input:-webkit-autofill:hover, input:-webkit-autofill:focus,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus':
          {
            WebkitTextFillColor: themeColors.onSecondaryAndDetailBackground,
            WebkitBoxShadow: `0 0 0px 1000px ${themeColors.secondaryBackground} inset`,
          },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        variant: 'primary',
      },

      variants: [
        {
          props: { variant: 'primary' },
          style: {
            color: themeColors.onIconsAndTextButtons,
            height: '32px',
            padding: '8px 24px',
            borderRadius: '5px',
            backgroundColor: themeColors.highlight,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 700,
            '&:hover': {
              backgroundColor: themeColors.hoverHighlight,
            },
            '&:disabled': {
              color: themeColors.primaryDisabledText,
              backgroundColor: themeColors.primaryDisabledBackground,
            },
          },
        },
        {
          props: { variant: 'secondary' },
          style: {
            padding: '8px 24px',
            borderRadius: '5px',
            color: themeColors.mainFocused,
            backgroundColor: themeColors.secondaryDisabledBackground,
            height: '32px',
            border: `solid 1px ${themeColors.borderLine}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            fontWeight: 700,
            '&:hover': {
              border: `solid 1px ${themeColors.mainFocused}`,
            },
            '&:disabled': {
              color: themeColors.secondaryDisabledText,
              border: `solid 1px ${themeColors.secondaryDisabledText}`,
            },
          },
        },
      ],
    },
  },
});

export const baseTheme = () => {
  const themeProperties = getCommonThemesProps(baseColors);
  const { palette, components } = themeProperties;

  return createTheme({
    breakpoints: {
      values: {
        xs: 360,
        sm: 500,
        md: 700,
        lg: 1024,
        xl: 1336,
        xxl: 1600,
        xxxl: 1750,
        xxxxl: 1920,
      },
    },
    palette,
    components,
    customLogo: {
      logo: 'FINANTECH_LOGO',
      slogo: 'FINANTECH_SLOGO',
      nlogo: 'FINANTECH_NLOGO',
      clogo: 'FINANTECH_CLOGO',
    },
    verticalBreakpoints: {
      lg: '709px',
      xl: '960px',
    },
    typography: {
      fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(),
    },
  });
};

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production') {
  window.theme = baseTheme();
}
